import { map } from '../../internal/core.esm.js';
import { addSupervisor as addSupervisor$1 } from '../../internal/layer/circular.esm.js';
import { SupervisorTypeId as SupervisorTypeId$1, fibersIn as fibersIn$1, fromEffect as fromEffect$1, none as none$1, track as track$1, unsafeTrack as unsafeTrack$1, ProxySupervisor, Zip, supervisorVariance } from '../../internal/supervisor.esm.js';

/**
 * A `Supervisor<T>` is allowed to supervise the launching and termination of
 * fibers, producing some visible value of type `T` from the supervision.
 *
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const SupervisorTypeId = SupervisorTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category context
 */
const addSupervisor = addSupervisor$1;

/**
 * Creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category constructors
 */
const fibersIn = fibersIn$1;

/**
 * Creates a new supervisor that constantly yields effect when polled
 *
 * @since 2.0.0
 * @category constructors
 */
const fromEffect = fromEffect$1;

/**
 * A supervisor that doesn't do anything in response to supervision events.
 *
 * @since 2.0.0
 * @category constructors
 */
const none = none$1;

/**
 * Creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category constructors
 */
const track = track$1;

/**
 * Unsafely creates a new supervisor that tracks children in a set.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeTrack = unsafeTrack$1;

/**
 * @since 2.0.0
 * @category constructors
 */
class AbstractSupervisor {
  /**
   * @since 2.0.0
   */

  /**
   * @since 2.0.0
   */
  onStart(_context, _effect, _parent, _fiber) {
    //
  }

  /**
   * @since 2.0.0
   */
  onEnd(_value, _fiber) {
    //
  }

  /**
   * @since 2.0.0
   */
  onEffect(_fiber, _effect) {
    //
  }

  /**
   * @since 2.0.0
   */
  onSuspend(_fiber) {
    //
  }

  /**
   * @since 2.0.0
   */
  onResume(_fiber) {
    //
  }

  /**
   * @since 2.0.0
   */
  map(f) {
    return new ProxySupervisor(this, () => map(this.value(), f));
  }

  /**
   * @since 2.0.0
   */
  zip(right) {
    return new Zip(this, right);
  }

  /**
   * @since 2.0.0
   */
  onRun(execution, _fiber) {
    return execution();
  }

  /**
   * @since 2.0.0
   */
  [SupervisorTypeId] = supervisorVariance;
}

export { AbstractSupervisor, SupervisorTypeId, addSupervisor, fibersIn, fromEffect, none, track, unsafeTrack };
